import { useTranslation } from "@refinedev/core"
import { HTMLAttributes } from "react"

export interface LoadingComponentProps extends HTMLAttributes<HTMLDivElement> {
    title?: string
    description?: string
}

export const LoadingComponent = ({
    title,
    description,
    className,
    ...rest
}: LoadingComponentProps) => {

    const { translate } = useTranslation()
        return <div className={`flex flex-col items-center justify-center h-full relative ${className ?? ''}`} {...rest}>
        <img src="/img/loading.png" alt="hachimind logo" className="w-24 h-24 animate-[spin_2s_linear_infinite]" />
        <div className="mt-4 flex flex-col items-center justify-center">
            <h2 className="text-xl font-bold text-secondary">{translate(title ?? 'common.loading')}</h2>
            <p className="text-seco/50 text-center w-64">{translate(description ?? 'common.loading-description')}</p>
        </div>
    </div>
}